<template>
  <JurnalList jenisJurnal="5" :title="title"  :routeInput="input" :routeEdit="edit" />
</template>

<script>
import JurnalList from '@/views/jurnal/JurnalList.vue';

export default {
    components: {
        JurnalList
    },
    data:() => ({
       title : 'Jurnal Pemakaian Persediaan (JPBIK)',
       input : 'jpbikinput',
       edit : 'jpbikedit'
    }),
    methods: {
       
    }
}
</script>


<style>

</style>